import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

import { Button } from '@wds/button';
import { ButtonGroup } from '@wds/button-group';
import { Input } from '@wds/input';

import { IconCheck, IconPencilPaper, IconX } from '@wds/icons';
import he from 'he';


export const InlineEditor = (props) => {
  const {
    text,
    placeholder,
    onFocusOut,
    editIcon,
    acceptIcon,
    rejectIcon,
    minimumLength
  } = props;
  let inlineEditor = useRef(null);

  const [state, setState] = useState({
    existingText: he.decode(text),
    newText: he.decode(text),
    isEditing: false,
  });

  useEffect(() => {
    const handleClick = (e, ref) => {
      if (ref && ref.current) {
        if (!ref.current.contains(e.target)) {
          rejectChanges();
        }
      }
    }

    document.addEventListener('mousedown', (e) => handleClick(e, inlineEditor), false);
    return () => {
      document.removeEventListener('mousedown', (e) => handleClick(e, inlineEditor), false);
    }
  }, [inlineEditor])

  const acceptChanges = () => {
    if (state.newText.trim().length < minimumLength) {
      return;
    }

    setState({
      ...state,
      existingText: he.decode(state.newText),
    });

    handleFocus();
  }

  const rejectChanges = () => {
    setState(prevState => {
      return {
        ...prevState,
        newText: prevState.existingText,
      }
    });

    handleFocus();
  }

  const handleFocus = () => {
    if (state.isEditing) {
      onFocusOut(state.newText);
    }

    setState(prevState => {
      return {
        ...prevState,
        isEditing: !prevState.isEditing,
      }
    });
  }

  const handleChange = (e) => {
    setState({
      ...state,
      newText: e.target.value,
    });
  }

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      acceptChanges();
    } else if (e.key === 'Escape') {
      rejectChanges();
    }
  }
  
  if (state.isEditing) {
    return (
      <div
        className="ads-inline-editor-editing"
        ref={inlineEditor}
      >
        <Input
          value={state.newText}
          onChange={handleChange}
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          autoFocus
      />
        <div className="ads-inline-editor-buttons">
          <ButtonGroup>
            <Button
              size="sm"
              color="secondary"
              onClick={rejectChanges}
              label="cancel button"
            >
              {rejectIcon}
            </Button>
            <Button
              size="sm"
              color="primary"
              onClick={acceptChanges}
              label="accept changes button"
            >
              {acceptIcon}
            </Button>
          </ButtonGroup>
        </div>
      </div>
    )
  }
  
  return (
    <div
      className="ads-inline-editor-display"
      onClick={handleFocus}
      onKeyDown={handleFocus}
      role="button"
      tabIndex={0}
    >
      
      <span>{state.existingText}</span>
      <Button
        variant="text"
        size="sm"
        color="secondary"
        label="edit button"
      >
        {editIcon}
      </Button>
    </div>
  )
}

InlineEditor.propTypes = {
  text: PropTypes.string,
  placeholder: PropTypes.string,
  onFocusOut: PropTypes.func,
  editIcon: PropTypes.element,
  acceptIcon: PropTypes.element,
  rejectIcon: PropTypes.element,
  minimumLength: PropTypes.number,
};

InlineEditor.defaultProps = {
  text: '',
  placeholder: '',
  onFocusOut: () => {},
  editIcon: <IconPencilPaper />,
  acceptIcon: <IconCheck />,
  rejectIcon: <IconX />,
  minimumLength: 0,
};
